// extracted by mini-css-extract-plugin
module.exports = {"input":"NumericInput_input__3c7-3"};